export const obras = [{
    "num": "1",
    "dependencia" : "SIPDUS",
    "municipio" : "Atlapexco",
    "nombre" : "Rehabilitación de la C.E. Atlapexco - Huejutla de Reyes del km 8+500 al 18+360, en el municipio de Atlapexco",
    "monto" : "65429039.57",
    "estatus" : "En ejecución",
    "fase" : "2"
},
    {
        "num": "2",
        "dependencia" : "SIPDUS",
        "municipio" : "Atlapexco",
        "nombre" : "Rehabilitación de la carretera estatal Atencuapa - E.C. (Atlapexco - Huejutla), en el municipio de Atlapexco",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "3",
        "dependencia" : "SIPDUS",
        "municipio" : "Atlapexco",
        "nombre" : "Rehabilitación de la C.E. Atlapexco - Tlalchiyahualica, en el municipio de Atlapexco",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "4",
        "dependencia" : "SIPDUS",
        "municipio" : "Atlapexco",
        "nombre" : "Rehabilitación de la C.E. Tlachapa - Cochiscoatitla - Cochotla, en el municipio de Atlapexco",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "5",
        "dependencia" : "SIPDUS",
        "municipio" : "Atlapexco",
        "nombre" : "Construcción de pavimentación hidráulica del camino Pahactla a Atlapexco, segunda etapa, en el municipio de Atlapexco",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "6",
        "dependencia" : "CEAA",
        "municipio" : "Atlapexco",
        "nombre" : "Construcción de cárcamo de bombeo del municipio de Atlapexco",
        "monto" : "7947178.42",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "7",
        "dependencia" : "SIPDUS",
        "municipio" : "Calnali",
        "nombre" : "Reconstrucción de la C.E. Calnali - San Andrés - Santa Lucía, segunda etapa, en el municipio de Calnali",
        "monto" : "12467833.46",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "8",
        "dependencia" : "SIPDUS",
        "municipio" : "Calnali",
        "nombre" : "Construcción de pavimentación hidráulica de camino en la localidad de Tostlamantla, en el municipio de Calnali",
        "monto" : "4863665.62",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "9",
        "dependencia" : "SIPDUS",
        "municipio" : "Calnali",
        "nombre" : "Reconstrucción de la C.E. Calnali - Papatlatla, segunda etapa, en el municipio de Calnali",
        "monto" : "12473862.81",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "10",
        "dependencia" : "SIPDUS",
        "municipio" : "Calnali",
        "nombre" : "Rehabilitación de la C.E. Ixtlahuaco - Calnali, en el municipio de Calnali",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "11",
        "dependencia" : "SIPDUS",
        "municipio" : "Calnali",
        "nombre" : "Rehabilitación de la C.E. ramal a Atempa, E.C. Calnali - Papatlatla, en el municipio de Calnali",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "12",
        "dependencia" : "CEAA",
        "municipio" : "Calnali",
        "nombre" : "Rehabilitación de drenaje sanitario, Calnali ",
        "monto" : "7874187.37",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "13",
        "dependencia" : "CEAA",
        "municipio" : "Calnali",
        "nombre" : "Reconstrucción de línea de conducción de sistema de agua potable en la localidad de Tula",
        "monto" : "1900000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "14",
        "dependencia" : "SICT",
        "municipio" : "CALNALI",
        "nombre" : "PUENTE PAPATLATLA",
        "monto" : "35000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "15",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "BOXO - EL TIXQUI - EL POTRERO – LOS LIRIOS-CIENEGUILLITA",
        "monto" : "32900000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "16",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "LIMITE IXMIQUILPAN-CARDONAL  - ARENALITO - LA MESA (INCLUYE RAMAL A PINALITO)",
        "monto" : "26200000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "17",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "EL BOTHO-LOS REYES",
        "monto" : "3000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "18",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "EL BINGU- EL DECA",
        "monto" : "3000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "19",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "LA FLORIDA - SAN CRISTOBAL",
        "monto" : "2000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "20",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "C.R. AGUACATLAN - LA MESA - LA GLORIA (INCLUYE RAMAL A JONACAPA)",
        "monto" : "16100000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "21",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "C. R. EL ROBLE-CIENEGUILLITAS - FRESNO - CIENEGUILLA",
        "monto" : "14400000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "22",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "C.R. LA FLORIDA - POZUELOS (INCLUYE RAMAL POZUELOS - SAN ANDRES DABOXTHA)",
        "monto" : "3000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "23",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "SAN ANTONIO SABANILLAS - SAN CRISTOBAL",
        "monto" : "2000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "24",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "CARDONAL - SANTUARIO MAPETHE",
        "monto" : "2500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "25",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "EL BUENA - SAN MIGUEL JIGUI",
        "monto" : "500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "26",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "PALACIOS - SAN CLEMENTE",
        "monto" : "250000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "27",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "POZUELOS - EL PALMAR",
        "monto" : "4000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "28",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "POZUELOS - LA HUERTA CAPULA",
        "monto" : "1500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "29",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "LA FLORIDA - EL PORVENIR",
        "monto" : "1000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "30",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "SAN CRISTOBAL - DOS CAMINOS",
        "monto" : "500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "31",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "SANTUARIO MAPETHE - EL NOGAL",
        "monto" : "500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "32",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "SANTUARIO MAPETHE - PIEDRA CHICA",
        "monto" : "500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "33",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "EL MOXTHE - TEPOZAN ",
        "monto" : "3200000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "34",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "CIENEGUILLITA - EL TEDRA",
        "monto" : "3600000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "35",
        "dependencia" : "SICT",
        "municipio" : "CARDONAL",
        "nombre" : "AGUACATLAN - EL AGUACATE",
        "monto" : "400000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "36",
        "dependencia" : "SIPDUS",
        "municipio" : "Chapulhuacán",
        "nombre" : "Reconstrucción de la C.E. ramal a Pisaflores del Km 0+000 al Km 2+200.",
        "monto" : "48829257.12",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "37",
        "dependencia" : "SIPDUS",
        "municipio" : "Chapulhuacán",
        "nombre" : "Construcción de pavimento hidráulico en calle de acceso a la localidad Nuevo Porvenir, en el municipio de Chapulhuacán",
        "monto" : "9311402.14",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "38",
        "dependencia" : "SIPDUS",
        "municipio" : "Chapulhuacán",
        "nombre" : "Terminación del sistema integral de agua potable en el municipio de Chapulhuacán",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "39",
        "dependencia" : "SIPDUS",
        "municipio" : "Chapulhuacán",
        "nombre" : "Construcción de pavimento hidráulico en calle de acceso al CECYTEH Plantel Chapulhuacán",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "40",
        "dependencia" : "SICT",
        "municipio" : "CHAPULHUACÁN",
        "nombre" : "CARRETERA TENANGO - CAHUAZAS",
        "monto" : "14400006.12",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "41",
        "dependencia" : "SICT",
        "municipio" : "CHAPULHUACÁN",
        "nombre" : "SOLEDAD DEL COYOL - E.C. (TEPEHUACÁN - SANTA ANA DE ALLENDE)",
        "monto" : "21699777.42",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "42",
        "dependencia" : "SICT",
        "municipio" : "CHAPULHUACÁN",
        "nombre" : "MIHUATLA-EL PESCADO",
        "monto" : "3149925.72",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "43",
        "dependencia" : "SICT",
        "municipio" : "CHAPULHUACÁN",
        "nombre" : "RAMAL AL ALGODONAL",
        "monto" : "3200219.16",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "44",
        "dependencia" : "SICT",
        "municipio" : "CHAPULHUACÁN",
        "nombre" : "PUENTE HUATEPANGO",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "45",
        "dependencia" : "SIPDUS",
        "municipio" : "Eloxochitlán",
        "nombre" : "Recontrucción del C.R. San Pedro Gilo - Otatla, en el municipio de Eloxochitlan",
        "monto" : "28057855.95",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "46",
        "dependencia" : "SIPDUS",
        "municipio" : "Eloxochitlán",
        "nombre" : "Rehabilitación del C.R. Chihuahua - La Mesa del Águila (acceso principal a las ollas de agua pluvial), en el municipio de Eloxochitlán",
        "monto" : "916612.71",
        "estatus" : "En ejecución",
        "fase" : "4"
    },
    {
        "num": "47",
        "dependencia" : "SICT",
        "municipio" : "ELOXOCHITLÁN",
        "nombre" : "C.E. ELOXOCHITLAN-MOLANGO",
        "monto" : "33079041.2666",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "48",
        "dependencia" : "SICT",
        "municipio" : "ELOXOCHITLÁN",
        "nombre" : "C.R. SAN PEDRO GILO - SAN MIGUEL ALMOLON",
        "monto" : "16823040.9458",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "49",
        "dependencia" : "SICT",
        "municipio" : "ELOXOCHITLÁN",
        "nombre" : "CR. SAN PEDRO GILO-OTATLA",
        "monto" : "16975188.5816",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "50",
        "dependencia" : "SICT",
        "municipio" : "ELOXOCHITLÁN",
        "nombre" : "C.R. CAMARONES - SAN JUAN AMAJAQUE",
        "monto" : "24032404.7016",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "51",
        "dependencia" : "SICT",
        "municipio" : "ELOXOCHITLÁN",
        "nombre" : "C.R. SAN JUAN AMAJAQUE - SAN MIGUEL ALMOLON",
        "monto" : "10111763.036",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "52",
        "dependencia" : "SICT",
        "municipio" : "ELOXOCHITLÁN",
        "nombre" : "C.R. TECOMATE - CHALMITA - ITZTACAPA",
        "monto" : "1841993.5336",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "53",
        "dependencia" : "SICT",
        "municipio" : "HUASCA DE OCAMPO",
        "nombre" : "PUENTE DE SAN SEBASTIÁN",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "54",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Construcción de pavimentación hidráulica en la localidad de Ahuatitla, en el municipio de Huautla",
        "monto" : "14916616.66",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "55",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Construcción de camino de concreto hidráulico tramo entronque carretera (Huautla - Chalingo) - Vinasco, en el municipio de Huautla",
        "monto" : "9118832.85",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "56",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Rehabilitación de la C.E. Huautla - Chalingo - Tzacuala, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "57",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Reconstrucción del C.R. La Loma - Huitzotlaco, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "58",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Rehabilitación del camino El Ixtle - Tepeco, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "59",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Reconstrucción del C.R. Cerezos - Ixtle, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "60",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Rehabilitación  del Camino Rural Tamoyón I - Huazalinguillo, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "61",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Reconstrucción del C.R. Barrio Hondo - Ahuehuetl, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "62",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Rehabilitación del C.R. Aquetzpalco - La Mesa, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "63",
        "dependencia" : "SIPDUS",
        "municipio" : "Huautla",
        "nombre" : "Reconstrucción del C.R. Terrero - Aquetzpalco, en el municipio de Huautla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "64",
        "dependencia" : "CEAA",
        "municipio" : "Huautla",
        "nombre" : "Construcción de sistema de agua potable en la localidad de el Cojolite",
        "monto" : "4915233.8",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "65",
        "dependencia" : "CEAA",
        "municipio" : "Huautla",
        "nombre" : "Reconstrucción de sistema de agua potable en la localidad de Tomoyón 1",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "66",
        "dependencia" : "SICT",
        "municipio" : "HUAUTLA",
        "nombre" : "PUENTE EL IXTLE",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "67",
        "dependencia" : "SICT",
        "municipio" : "HUAUTLA",
        "nombre" : "PUENTE VADO COAPANTLA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "68",
        "dependencia" : "SICT",
        "municipio" : "HUAUTLA",
        "nombre" : "PUENTE EL COJOLITE",
        "monto" : "51000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "69",
        "dependencia" : "SICT",
        "municipio" : "HUAUTLA",
        "nombre" : "PUENTE BANDERAS (CALABOZO TAMOYON)",
        "monto" : "90000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "70",
        "dependencia" : "SIPDUS",
        "municipio" : "Huazalingo",
        "nombre" : "Construcción de tanque público de agua potable y rehabilitación del sistema de agua entubada en el municipio de Huazalingo",
        "monto" : "10570063.26",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "71",
        "dependencia" : "SIPDUS",
        "municipio" : "Huazalingo",
        "nombre" : "Rehabilitación del C.E. Tehuetlán - Huazalingo, en el municipio de Huazalingo",
        "monto" : "85730429.08",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "72",
        "dependencia" : "SIPDUS",
        "municipio" : "Huazalingo",
        "nombre" : "Rehabilitación del C.R. de acceso a la localidad de Pilchiatipa, en el municipio de Huazalingo",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "73",
        "dependencia" : "SIPDUS",
        "municipio" : "Huazalingo",
        "nombre" : "Rehabilitación del C.R. en la localidad de Copaltitla - Cuamontax, en el municipio de Huazalingo",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "74",
        "dependencia" : "SIPDUS",
        "municipio" : "Huehuetla",
        "nombre" : "Recontrucción del C.R. San Andrés - El Canjoy - San Ambrosio - a los Lim.Edos. Hgo./Ver (incluye ramal a El Chamizal), en el municipio de Huehuetla",
        "monto" : "27018636.93",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "75",
        "dependencia" : "CEAA",
        "municipio" : "Huehuetla",
        "nombre" : "Rehabilitación de red o sistema de agua entubada en la localidad de Santa Úrsula",
        "monto" : "2511918.59",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "76",
        "dependencia" : "CEAA",
        "municipio" : "Huehuetla",
        "nombre" : "Reconstrucción de captación El Bosque de Sistema de Agua Potable, de la cabecera municipal, municipio de Huehuetla, Estado de Hidalgo.",
        "monto" : "1476752.86",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "77",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. JUNTAS CHICAS - SAN LORENZO ACHIOTEPEC- LA ESPERANZA DOS - HDA. EL POTRERO - RAMALES A  RÍO BELTRAN Y EL ENCINAL",
        "monto" : "51641690.27",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "78",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. SAN LORENZO ACHIOTEPEC - EL BORBOLLON",
        "monto" : "13060910.73",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "79",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. JUNTAS CHICAS - PALO VERDE - EL DENXE",
        "monto" : "23360301.72",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "80",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. ACUAUTLA - SAN GREGORIO . LIM. EDOS. HGO/PUE.",
        "monto" : "14410698.24",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "81",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. SAN GREGORIO - SAN AMBROSIO",
        "monto" : "26303042.8",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "82",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. CERRO DEL TOMATE - HUEHUETLA - SAN ANTONIO EL GRANDE - ACUAUTLA ",
        "monto" : "74532867.16",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "83",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "E.C (SAN LORENZO ACHIOTEPEC - IXHUATLAN DE MADERO) - EL XOTHE - XOÑE",
        "monto" : "11658722.08",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "84",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "E.C(JUNTAS CHICAS - SAN LORENZO ACHIOTEPEC) - TEMPESQUITE - LA PIMIENTA",
        "monto" : "15205100.26",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "85",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "JUNTAS CHICAS - LIM. (HGO-VER)",
        "monto" : "15554341.62",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "86",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "SANTA MARÍA TEMAXCALAPA - HUEHUETLA",
        "monto" : "30000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "87",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "PUENTE RIO BLANCO",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "88",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "PUENTE ZICATLAN",
        "monto" : "20000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "89",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. SAN ANDRES - EL CANJOY - SAN AMBROSIO - LIM. EDOS. HGO./VER.-(INCLUYE RAMAL A EL CHAMIZAL)",
        "monto" : "27054193.26",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "90",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. SAN ANDRES - SAN ESTEBAN - JUNTAS CHICAS",
        "monto" : "51494942.01",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "91",
        "dependencia" : "SICT",
        "municipio" : "HUEHUETLA",
        "nombre" : "C.R. ACUAUTLA - BARRIO DEL CANJOY - LOMA DE BUENAVISTA - SAN ANDRES",
        "monto" : "38273066.075",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "92",
        "dependencia" : "SIPDUS",
        "municipio" : "Huejutla de Reyes",
        "nombre" : "Reconstrucción de la C.E. Huejutla- Chalahuiyapa-Los Otates, segunda etapa, en el municipio de Huejutla de Reyes",
        "monto" : "9961343.35",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "93",
        "dependencia" : "SIPDUS",
        "municipio" : "Huejutla de Reyes",
        "nombre" : "Construcción de techumbre en espacio publico multideportivo, en la colonia Parque de Poblamiento, localidad de Col. Parque de Poblamiento, municipio de Huejutla de Reyes",
        "monto" : "2336491.4",
        "estatus" : "Concluida",
        "fase" : "4"
    },
    {
        "num": "94",
        "dependencia" : "CEAA",
        "municipio" : "Ixmiquilpan ",
        "nombre" : "Construcción de línea de distribución en la localidad de El Dexthi Alberto",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "95",
        "dependencia" : "SIPDUS",
        "municipio" : "Jacala de Ledezma",
        "nombre" : "Rehabilitación del sistema de agua potable en manantial \"El Ushi\", en la localidad de La Palma, en el municipio de Jacala de Ledezma",
        "monto" : "2991136.97",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "96",
        "dependencia" : "SIPDUS",
        "municipio" : "Jacala de Ledezma",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales en la comunidad de Plomosas, en el municipio de Jacala de Ledezma.",
        "monto" : "4837949.97",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "97",
        "dependencia" : "SIPDUS",
        "municipio" : "Jacala de Ledezma",
        "nombre" : "Construcción de dos puentes colgantes sobre el Río Amajac en las localidades de Vado Hondo y San Andresito ubicados en los límites de los municipios de Jacala de Ledezma y Tlahuiltepa",
        "monto" : "7331127.35",
        "estatus" : "En ejecución",
        "fase" : "4"
    },
    {
        "num": "98",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "BARRANCA ARRIBA - SAN NICOLÁS - GUAYABOS",
        "monto" : "1800000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "99",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "C.R. OCTUPILLA - QUETZALAPA - VADO HONDO",
        "monto" : "40000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "100",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "C.R. SANTO DOMINGO-RANCHO NUEVO-QUETZALAPA",
        "monto" : "12000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "101",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "E.C.(SAN NICOLAS-OCTUPILLA)- PLOMOSAS - MINAS VIEJAS",
        "monto" : "7300000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "102",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "JACALA-BARRIO EL AGUAJE",
        "monto" : "2000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "103",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "LLANITOS - OCTUPILLA -  SANTO DOMINGO",
        "monto" : "10500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "104",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "RAMAL A AGUA FRÍA CHICA",
        "monto" : "1200000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "105",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "LA PALMA-SANTO DOMINGO(PASO COMATITLAN)",
        "monto" : "9600000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "106",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "PUENTE QUETZALAPA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "107",
        "dependencia" : "SICT",
        "municipio" : "JACALA DE LEDEZMA",
        "nombre" : "PUENTE LA PALMA",
        "monto" : "15000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "108",
        "dependencia" : "CEAA",
        "municipio" : "Jacala de Ledezma.",
        "nombre" : "Rehabilitación del sistema de agua potable en la localidad de Santo Domingo",
        "monto" : "2922110.88",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "109",
        "dependencia" : "CEAA",
        "municipio" : "Jacala de Ledezma.",
        "nombre" : "Rehabilitación de línea de agua potable de la localidad de Quetzalapa",
        "monto" : "2089000.94",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "110",
        "dependencia" : "SIPDUS",
        "municipio" : "Juárez Hidalgo",
        "nombre" : "Pavimentación de concreto hidráulico en camino rural Santa María - San Nicolás, en el municipio de Juárez Hidalgo",
        "monto" : "8704316.13",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "111",
        "dependencia" : "SIPDUS",
        "municipio" : "Juárez Hidalgo",
        "nombre" : "Construcción de muros de contención en el municipio de Juárez Hidalgo",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "112",
        "dependencia" : "CEAA",
        "municipio" : "Juárez Hidalgo",
        "nombre" : "Rehabilitación de sistema de agua potable en Juárez Hidalgo",
        "monto" : "8841822.12",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "113",
        "dependencia" : "CEAA",
        "municipio" : "Juárez Hidalgo",
        "nombre" : "Rehabilitación del sistema de drenaje sanitario en Bo. La Laguna ",
        "monto" : "3159460.05",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "114",
        "dependencia" : "CEAA",
        "municipio" : "Juárez Hidalgo",
        "nombre" : "Reconstrucción de tanque de regularización de agua potable 50 m3 en Santa María",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "115",
        "dependencia" : "SIPDUS",
        "municipio" : "La Misión",
        "nombre" : "Construcción de pavimentación hidráulica de calle sin nombre en tramo Encino Largo - Cerro Prieto, en Encino Largo, municipio de La Misión",
        "monto" : "7418212.64",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "116",
        "dependencia" : "SIPDUS",
        "municipio" : "La Misión",
        "nombre" : "Pavimentación hidráulica La Misión - Puerto de Naranjos, subtramo La Misión - Loma de Perción, en el municipio de la misión",
        "monto" : "7019553.33",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "117",
        "dependencia" : "SIPDUS",
        "municipio" : "La Misión",
        "nombre" : "Construcción de muro de contención y pavimentación de concreto hidráulico en calle Emiliano Zapata, Bo. De santa María, municipio de La Misión",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "4"
    },
    {
        "num": "118",
        "dependencia" : "SIPDUS",
        "municipio" : "La Misión",
        "nombre" : "Construcción de muro de contención en cabecera municipal, calle Gral. Porfirio Rubio y 20 de Noviembre, en el municipio de La Misión",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "4"
    },
    {
        "num": "119",
        "dependencia" : "CEAA",
        "municipio" : "La Misión",
        "nombre" : "Rehabilitación de la línea de conducción del sistema de agua potable en la localidad de Vega de la Carrera",
        "monto" : "912000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "120",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "ACCESO A LA HONDURA",
        "monto" : "2749963.33",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "121",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "C.R. LA MISIÓN - LOMA DE PERICON - PUERTO LOS NARANJOS (INCLUYE RAMAL A LA MORA)",
        "monto" : "3365881.44",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "122",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "C.R. PUERTO PIEDRA - MACANGUI -  AGUAJE DE CERRO PRIETO (INCLUYE RAMAL A COÑE VIEJO Y RAMAL A TIERRA CALIENTE)",
        "monto" : "18857054.48",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "123",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "CUESTA COLORADA - LA CIENEGA - PUERTO DEL ALGODÓN-CAÑITAS",
        "monto" : "49860206.17",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "124",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "DAMATHI - VEGA DE LA CARRERA",
        "monto" : "17999876.3",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "125",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "EL CHAMAL - ZIPATLA E.C (JACALA - CHAPULHUACÁN) INCLUYE RAMAL A ZIPATLA",
        "monto" : "6456894.49",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "126",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LA CULEBRA-NARANJITAS MACOJU",
        "monto" : "7039998.25",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "127",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LA MISIÓN - LA PALIZADA - EL FRESNO",
        "monto" : "16809856.08",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "128",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LA MISION-SAN CRISTOBAL",
        "monto" : "30000016.11",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "129",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "PUERTO DE NARANJOS-LA SOLEDAD",
        "monto" : "6654937.41",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "130",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LA MORA-RIO MOCTEZUMA",
        "monto" : "8788931.77",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "131",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LAS PILAS-LOMA DE PILAS",
        "monto" : "6599876.93",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "132",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LOMA DE PILAS-BARRIO ALTO",
        "monto" : "1154925.6",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "133",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LAS PILAS-MESA DE PILAS",
        "monto" : "3761806.42",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "134",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "ENTRONQUE EL NARANJO - EL TEPEHUAJE",
        "monto" : "1715959.32",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "135",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "LA TINAJA-EL LLANO",
        "monto" : "1869770.77",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "136",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "EL LLANO-EL RAYO",
        "monto" : "1869770.77",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "137",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "PALO HUECO- EL MEXE",
        "monto" : "2882005.8",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "138",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "PARAJE-PUERTO DE LA CULEBRA",
        "monto" : "1045161.64",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "139",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "CERRO PRIETO - MESA DEL FRESNO",
        "monto" : "3553120.17",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "140",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "CERRO PRIETO - LA JOYA",
        "monto" : "3410008.77",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "141",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : " LA JOYA - EL FRESNO",
        "monto" : "2271280.03",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "142",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "NOGALITO - NOGAL DE CERRO PRIETO",
        "monto" : "1633328.55",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "143",
        "dependencia" : "SICT",
        "municipio" : "LA MISIÓN",
        "nombre" : "MACANGUI - LOMA DE MACANGUI",
        "monto" : "1594975.2",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "144",
        "dependencia" : "SIPDUS",
        "municipio" : "Lolotla",
        "nombre" : "Construcción de pavimentación de concreto hidráulico acceso a localidad de Acatepec, municipio de Lolotla",
        "monto" : "14554282.99",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "145",
        "dependencia" : "SIPDUS",
        "municipio" : "Lolotla",
        "nombre" : "Reconstrucción del C.R.  Atoscalao - Tetlapaya km. 2+500, en el municipio de Lolotla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "146",
        "dependencia" : "SICT",
        "municipio" : "LOLOTLA",
        "nombre" : "PUENTE XUCHIPANTLA",
        "monto" : "55000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "147",
        "dependencia" : "CEAA",
        "municipio" : "Metztitlan",
        "nombre" : "Construcción de línea de conduccion de agua potable en la localidad de San Antonio Tlaxco",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "148",
        "dependencia" : "SIPDUS",
        "municipio" : "Metztitlán",
        "nombre" : "Reconstrucción de la calle 12 de diciembre, en la localidad de El Damhu, en el municipio de Metztitlán",
        "monto" : "1000610.2",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "149",
        "dependencia" : "SIPDUS",
        "municipio" : "Metztitlán",
        "nombre" : "Pavimentación de carretera del tramo libramiento de Metztitlán",
        "monto" : "10262175.22",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "150",
        "dependencia" : "SIPDUS",
        "municipio" : "Metztitlán",
        "nombre" : "Construcción de pavimentación hidráulica en calle principal de la comunidad de Tlatepexe, en el municipio de Metztitán",
        "monto" : "2719712.48",
        "estatus" : "En ejecución",
        "fase" : "4"
    },
    {
        "num": "151",
        "dependencia" : "SIPDUS",
        "municipio" : "Metztitlán",
        "nombre" : "Construcción de piso pórfido y rehabilitación de drenaje sanitario, red de agua potable de calle Lázaro Cárdenas del Centro Histórico, en el municipio de Metztitlán",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "152",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.E. METZTITLAN - SAN CRISTOBAL",
        "monto" : "14666605.0464",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "153",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.E. TRAMO VENADOS -METZTITLAN - ELOXOCHITLAN ",
        "monto" : "22039803.67348",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "154",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.R. CERRO VERDE - SANTA MONICA -JILOTLA",
        "monto" : "51136405.338",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "155",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.R. METZNOXTLA-SAN PABLO TETLAPAYAC",
        "monto" : "17519312.89504",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "156",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.R. SAN JUAN TLATEPEXI- MILPA GRANDE - AGUA HEDEONDA (INCLUYE RAMAL A EL MEJE)",
        "monto" : "31408913.2576",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "157",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.R. TEZOCHUCA - ZOQUIZOQUIPAN - LOS ARCOS - LA MESA GRANDE",
        "monto" : "30834296.1912",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "158",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "MEZTITLAN (TRAMO AMAJATLAN) - SAN CRISTOBAL Y RAMAL A CERRO PARTIDO",
        "monto" : "1355140.536",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "159",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.R. ZOTOLA - ATZOLTCINTLA (INCLUYE RAMAL A ITZTAZACUALA)",
        "monto" : "28926152.1264",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "160",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "EL PIRU DE TEPOZOTLAN - CHIMALACATLA",
        "monto" : "20210252.54",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "161",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.E. SAN JUAN-ZOQUIZOQUIPAN",
        "monto" : "1775839.824",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "162",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : " C.R. HUAYATENO - TLAXCO - HUALULA",
        "monto" : "14926529.4248",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "163",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "C.R. ITZTAYATLA - METZTITLAN",
        "monto" : "9611599.2704",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "164",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : " C.R. LOS ARCOS - ITZTAYATLA - TEPATETIPA - TLATEPEXE",
        "monto" : "18172764.624",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "165",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "PUENTE JILOTLA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "166",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "PUENTE AYACATZINTLA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "167",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "PUENTE JIHUICO",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "168",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "PUENTE SAN CRISTOBAL",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "169",
        "dependencia" : "SICT",
        "municipio" : "METZTITLÁN",
        "nombre" : "PUENTE TRES CRUCES",
        "monto" : "15000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "170",
        "dependencia" : "SIPDUS",
        "municipio" : "Molango de Escamilla",
        "nombre" : "Construcción de pavimentación hidráulica en calle hacia el panteón, barrio Santa Cruz, en la localidad de Malila, municipio de Molango de Escamilla",
        "monto" : "5811706.22",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "171",
        "dependencia" : "SIPDUS",
        "municipio" : "Molango de Escamilla",
        "nombre" : "Rehabilitación del C.R. Ixcuicuila - San Miguel Ayotempa - San Simón, en el municipio de Molango de Escamilla",
        "monto" : "17207034.12",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "172",
        "dependencia" : "SIPDUS",
        "municipio" : "Molango de Escamilla",
        "nombre" : "Construcción de línea de conducción de agua potable de la localidad de Ixcuicuila, municipio de Molango de Escamilla.",
        "monto" : "8033381.45",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "173",
        "dependencia" : "SIPDUS",
        "municipio" : "Molango de Escamilla",
        "nombre" : "Reconstrucción del C.R. Naopa – Tetipanchalco - Tlatzintla - Ixcatlán, en el municipio de Molango de Escamilla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "174",
        "dependencia" : "SIPDUS",
        "municipio" : "Molango de Escamilla",
        "nombre" : "Rehabilitación C.E. acceso a  Molango, en el municipio de Molango de Escamilla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "175",
        "dependencia" : "SICT",
        "municipio" : "MOLANGO DE ESCAMILLA",
        "nombre" : "PUENTE TETIPANCHALCO",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "176",
        "dependencia" : "CEAA",
        "municipio" : "Molango de Escamilla.",
        "nombre" : "Rehabilitación de línea de conducción y sustitución de un cárcamo de bombeo, del sistema de conducción en la localidad de San Antonio",
        "monto" : "1590089.69",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "177",
        "dependencia" : "CEAA",
        "municipio" : "Molango de Escamilla.",
        "nombre" : "Rehabilitación de linea de agua potable en la localidad de Cuxhuacan",
        "monto" : "1031520",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "178",
        "dependencia" : "CEAA",
        "municipio" : "Molango de Escamilla.",
        "nombre" : "Rehabilitación de linea conducción de agua potable en la localidad de Temacuil",
        "monto" : "574950",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "179",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores",
        "nombre" : "Reconstrucción de la C.E. acceso a Nicolás Flores, segunda etapa, en la localidad Santa Cruz, en el municipio de Nicolás Flores",
        "monto" : "19950778.15",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "180",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores",
        "nombre" : "Reconstrucción de la C.E. Ixmiquilpan - Cardonal - Santuario",
        "monto" : "37442949.88",
        "estatus" : "Concluida",
        "fase" : "2"
    },
    {
        "num": "181",
        "dependencia" : "CEAA",
        "municipio" : "Nicolás Flores",
        "nombre" : "Rehabilitación del sistema de agua potable en la localidad Del Cobre",
        "monto" : "3173336.9",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "182",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "C.E. SANTUARIO-NICOLAS FLORES",
        "monto" : "37500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "183",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "C.R. CIENEGA - NICOLAS FLORES",
        "monto" : "65999859.07",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "184",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "C.R. LA BONANZA-TAXHAY -NICOLAS FLORES",
        "monto" : "22199926.83",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "185",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "C.R. SANTO DOMINGO - ITATLAXCO",
        "monto" : "11800043.18",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "186",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "E.C.(TRANCAS NICOLAS FLORES)- ITATLAXCO-SOYATAL",
        "monto" : "22200087.54",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "187",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "EL COBRE - EL AGUACATE",
        "monto" : "19999780.06",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "188",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "TEXCAHO-BOCUA",
        "monto" : "10319837.949",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "189",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "BOCUA-CERRO DE LA CRUZ",
        "monto" : "8900033.11",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "190",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "PUERTO DE PIEDRA-ZOYATAL",
        "monto" : "17000229.71",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "191",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "MILPAS-PUERTO DE PIEDRA",
        "monto" : "8500036.25",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "192",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "MILPAS-VILLA JUAREZ",
        "monto" : "18000147.25",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "193",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "EL COBRE-LA ENCARNACION",
        "monto" : "10999907.21",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "194",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "LA CIENEGA-E.C.(TRANCAS-NICOLAS FLORES)",
        "monto" : "11999916.74",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "195",
        "dependencia" : "SICT",
        "municipio" : "NICOLÁS FLORES",
        "nombre" : "PUENTE SANTO DOMINGO",
        "monto" : "15000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "196",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores ",
        "nombre" : "Reposición de la línea de conducción y redes de distribución en la localidad de El Aguacate, en el municipio de Nicolás Flores",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "197",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores ",
        "nombre" : "Reposición de la línea de conducción por gravedad y redes de distribución de  en la localidad de Cerro de la Cruz, en el municipio de Nicolás Flores",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "198",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores ",
        "nombre" : "Reposición de planta de tratamiento en la localidad de el Dothu, en el municipio de Nicolás Flores",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "199",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores ",
        "nombre" : "Reposición de la línea de conducción por gravedad y redes de distribución en la localidad de Segundo Centro en el municipio de Nicolás Flores",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "200",
        "dependencia" : "SIPDUS",
        "municipio" : "Nicolás Flores ",
        "nombre" : "Reposición de la línea de conducción por gravedad y redes de distribución de 2\" de fierro galvanizado de la localidad de Santa Cruz, en el municipio de Nicolás Flores",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "201",
        "dependencia" : "SIPDUS",
        "municipio" : "Pacula",
        "nombre" : "Construcción de muro de contención y alcantarilla sobre carretera Pacula - El Puerto, en la localidad de Jilapan, municipio de Pacula",
        "monto" : "3422879.65",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "202",
        "dependencia" : "SIPDUS",
        "municipio" : "Pacula",
        "nombre" : "Construcción de línea de conducción de agua potable para beneficiar a las comunidades de Santa María, Puerto Grande y La Mohonera, en el municipio de Pacula",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "203",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "ACCESO A JILIAPAN",
        "monto" : "9399799.4872",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "204",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "ACCESO A MIXQUIAHUALES",
        "monto" : "6000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "205",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "C.E. SAUCILLO - JILIAPAN",
        "monto" : "3000097.71",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "206",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "C.R. ADJUNTAS - EL MEZQUITE",
        "monto" : "4499762.07",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "207",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "RANCHO NUEVO-POTRERILLOS",
        "monto" : "550036.4",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "208",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "LOS CORRALES-AGUACATITO",
        "monto" : "11999762.23",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "209",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "PUERTO DEL REPARO-CANOAS",
        "monto" : "4499926.82",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "210",
        "dependencia" : "SICT",
        "municipio" : "PACULA",
        "nombre" : "RAMAL AL DIVISADERO",
        "monto" : "1000147.22",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "211",
        "dependencia" : "SIPDUS",
        "municipio" : "Pisaflores",
        "nombre" : "Pavimentación de concreto hidráulico en camino rural La Gargantilla - Tripuente, en el municipio de Pisaflores",
        "monto" : "3961019.11",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "212",
        "dependencia" : "SIPDUS",
        "municipio" : "Pisaflores",
        "nombre" : "Rehabilitación de la C.E. Chapulhuacán - Pisaflores, en el municipio de Pisaflores",
        "monto" : "",
        "estatus" : "En Validación",
        "fase" : "4"
    },
    {
        "num": "213",
        "dependencia" : "CEAA",
        "municipio" : "Pisaflores",
        "nombre" : "Rehabilitación de Colector Sanitario y Biodigestores de la localidad de El Limoncito, municipio de Pisaflores.",
        "monto" : "548470.49",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "214",
        "dependencia" : "CEAA",
        "municipio" : "Pisaflores",
        "nombre" : "Rehabilitación de línea de conducción de agua potable en la comunidad de Palmitas",
        "monto" : "268378.29",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "215",
        "dependencia" : "CEAA",
        "municipio" : "Pisaflores",
        "nombre" : "Rehabilitación de línea de conducción de agua potable en la localidad de Pisaflores",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "216",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : " C.R EL RAYO-LA LAGUNA",
        "monto" : "14399884.1",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "217",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "C.R. EL RAYO - PISAFLORES",
        "monto" : "9599916.32",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "218",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "PISAFLORES - CERRO DEL CARMEN - EL RAYO",
        "monto" : "12000009.0872",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "219",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "C.R. PISAFLORES - CHALAHUITE",
        "monto" : "50000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "220",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "PISAFLORES-LA PEÑA",
        "monto" : "20000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "221",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "LA PEÑA-GUAYBOS",
        "monto" : "7999993.72",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "222",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "BONIGU-SAN VICENTE-EL AMOLAR",
        "monto" : "9360028.61",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "223",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "LA FLORIDA-SAN PEDRO XOCHUCUACO",
        "monto" : "9360028.61",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "224",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "LAS MORAS -ZAPOTAL DE MORAS",
        "monto" : "8999881.1",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "225",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "ZAPOTAL DE MORAS-PLAN DE ZAPOTAL",
        "monto" : "1680196.62",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "226",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "LA ARENA-CHALAHITITO",
        "monto" : "3959878.74",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "227",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "LA ARENA-LAS MORAS",
        "monto" : "3119761.58",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "228",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "LA PECHUGA-MIRAFLORES",
        "monto" : "5399830.64",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "229",
        "dependencia" : "SICT",
        "municipio" : "PISAFLORES",
        "nombre" : "CHALHUITE- GARGANTILLA",
        "monto" : "10799822.57",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "230",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "C.R TRAMO IGLESIA VIEJA OCUICALCO-LAS CAÑADITAS",
        "monto" : "2753375.9188",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "231",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "TRAMO ZAHUASTIPAN- TZINCOATLAN- E.C. A SANTO DOMINGO",
        "monto" : "16024856.1572",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "232",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "C.R. EL LLANO DE AGUA BENDITA - APARTADERO",
        "monto" : "5599407.4988",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "233",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "C.R MILPILLAS - TERRERO-CANOAS-JILIAPA",
        "monto" : "9437994.5288",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "234",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "C.R TRAMO SAN AGUSTÍN METZQUITITLÁN ( BARRIO LA CAÑADA)",
        "monto" : "2698545.1896",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "235",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "C.R. ARROYO HONDO - CIENEGUILLAS - TUZANAPA",
        "monto" : "9582832.4304",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "236",
        "dependencia" : "SICT",
        "municipio" : "SAN AGUSTÍN METZQUITITLÁN",
        "nombre" : "C.R. SANTA MARIA XOXOTECO - ALAMOS",
        "monto" : "26355653.1656",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "237",
        "dependencia" : "SIPDUS",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Reconstrucción de la C.E. San Bartolo - San Miguel (segunda etapa), municipio de San Bartolo Tutotepec",
        "monto" : "19976342.04",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "238",
        "dependencia" : "SIPDUS",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Construcción de Tanque público de agua potable y Sistema de agua entubada de Santiago a San Bartolo Tutotepec, en el municipio de San Bartolo Tutotepec",
        "monto" : "1867338.27",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "239",
        "dependencia" : "SIPDUS",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Reconstrucción de la C.E. Santa María Temaxcalapa - San Bartolo Tutotepec - Ramal Buena Vista, en el municipio de San Bartolo Tutotepec",
        "monto" : "27019230.6",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "240",
        "dependencia" : "SIPDUS",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Obra complementaria para la construcción de puente en camino de acceso principal a la localidad El Piñal, San Bartolo Tutotepec",
        "monto" : "14488459.95",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "241",
        "dependencia" : "SIPDUS",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Reposición de la línea de conducción de agua potable en la localidad La Industrial, municipio de San Bartolo Tutotepec.",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "242",
        "dependencia" : "SIPDUS",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Estudio de geotecnia y propiedades mecánicas del suelo para el predio “La Antena” ubicado en la Col. La Industrial, en el Municipio de San Bartolo Tutotepec",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "243",
        "dependencia" : "CEAA",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Rehabilitación del sistema de agua potable en la localidad de Huasquilla ",
        "monto" : "1413446.5",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "244",
        "dependencia" : "CEAA",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Reconstrucción del sistema de agua potable en la localidad de las Juntas",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "245",
        "dependencia" : "CEAA",
        "municipio" : "San Bartolo Tutotepec",
        "nombre" : "Reconstrucción del sistema de agua potable en la localidad de El Lindero Chico",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "246",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.E. SANTA MARIA TEMAZCALAPA - SAN BARTOLO TUTOTEPEC - RAMAL BUENA VISTA",
        "monto" : "73226819.54",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "247",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "RAMALES: SAN BARTOLO  - EL MAVODO Y SAN BARTOLO - EL PEDREGAL",
        "monto" : "19256989.08",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "248",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. RÍO CHICO - MEDIO MONTE - TUTOTEPEC - LA VEREDA",
        "monto" : "27046334.88",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "249",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. LA VENTA - SAN JUAN DE LAS FLORES - EL XUCHITL - RAMALES: A SANTA CRUZ, A XUCHITLÁN, AGUA ESCONDIDA Y A PALO GORDO",
        "monto" : "89756458.1",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "250",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. CHICAMOLE -  LA VENTA - EL MAHUAQUITE - RAMALES: A TIERRA FUERTE Y A EL JOVIÓN",
        "monto" : "25635132.04",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "251",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "MEDIO MONTE - EL ENCINAL",
        "monto" : "8664756.07",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "252",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "TUTOTEPEC - MAHUAQUITE",
        "monto" : "15489621.23",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "253",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "TIERRA FUERTE - XUCHITLÁN",
        "monto" : "31489625.2",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "254",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "LA CUMBRE DE LA CAMPANA - LA CAMPANA",
        "monto" : "10700395.47",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "255",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. E.C. (EL DESDAVI - EL CASIU)  -  RINCON DEL CERRO MACHO",
        "monto" : "30636422.02",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "256",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R.  SAN MIGUEL - CERRO NEGRO - SAN MATEO - EL PARAISO DE TIERRA FUERTE - RAMALES: A SAN GABRIEL, A LA SEGUNDA RANCHERÍA Y A CERRO VERDE",
        "monto" : "130847974.12",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "257",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. SANTIAGO -SAN MIGUEL - EL COPAL -RAMAL POPOTILLO GRANDE",
        "monto" : "64875064.01",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "258",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. SAN MATEO - SAN JERONIMO - EL PIÑAL",
        "monto" : "72193492.6",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "259",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "E.C CERRO VERDE - E.C SAN MATEO",
        "monto" : "20143073.61",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "260",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. SAN ANDRES - AGUA GRANDE - EL VEINTE - SAN SEBATIÁN - RAMALES A SAN JERÓNIMO, A COJOLITE Y  A MILPA LARGA",
        "monto" : "120284089.186667",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "261",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "EL XÚCHITL - JUNTAS DEL RÍO",
        "monto" : "26673661.08",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "262",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "LA PLAZUELA",
        "monto" : "3187654.628",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "263",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "PUENTE CAMARONES",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "264",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. SAN BARTOLO - CUMBRE DE MURIDORES - RAMAL AL NANDHO",
        "monto" : "86906679.6",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "265",
        "dependencia" : "SICT",
        "municipio" : "SAN BARTOLO TUTOTEPEC",
        "nombre" : "C.R. MEDIO MONTE - PUEBLO NUEVO - EL SEIS - RAMALES A CHICAMOLE Y A HUASQUILLA",
        "monto" : "89172377.5",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "266",
        "dependencia" : "SICT",
        "municipio" : "SANTIAGO DE ANAYA",
        "nombre" : "PUENTE ”DREN SAN JUAN”",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "267",
        "dependencia" : "SIPDUS",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstrucción de la C.E. Metepec- Tenango - Santa Marïa Temaxcalapa - Huasquilla - Ramales al Despi, en el municipio de Tenango de Doria",
        "monto" : "46993329.95",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "268",
        "dependencia" : "SIPDUS",
        "municipio" : "Tenango de Doria",
        "nombre" : "Pavimentación de camino rural tramo Piedras  Negras a El Bopo, municipio de Tenango de Doria",
        "monto" : "8376789.87",
        "estatus" : "Concluida",
        "fase" : "2"
    },
    {
        "num": "269",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Rehabilitación de sistema de agua potable en la cabecera municipal Tenango de Doria",
        "monto" : "2647627.99",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "270",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Rehabilitación de sistema de agua potable integral en las localidades de La Reforma, El Casiu y Las Juntas",
        "monto" : "1189616.46",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "271",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstruccion de fosa septica en la localidad de el Temapá",
        "monto" : "545134.15",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "272",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstrucción de liena de agua potable en la localidad de Santa Maria Temaxcalapa",
        "monto" : "374699.46",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "273",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstruccion de sistema de drenaje sanitario de la localidad de colonia de San José",
        "monto" : "382245.13",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "274",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstruccion de sistema de drenaje y alcantarillado localidad del Dequeña",
        "monto" : "466048.25",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "275",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstrucción de red de alcantarillado en la localidad de Huasquilla",
        "monto" : "1055950.7",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "276",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstruccion de sistema de drenaje sanitario en la localidad de San Isidro",
        "monto" : "525285.07",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "277",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstrucción del sistema de agua potable en la localidad de El Damo",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "278",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstrucción del sistema de agua potable en la localidad de el Temapa",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "279",
        "dependencia" : "CEAA",
        "municipio" : "Tenango de Doria",
        "nombre" : "Reconstrucción del sistema de agua potable en la localidad de la Colonia Ermita",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "280",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "CAMINO BOPO - EL TENEXCO - SANTA MARÍA TEMAXCALAPA",
        "monto" : "8715271.5744",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "281",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "EL POTRERO - SANTA MONICA - SAN NICOLÁS",
        "monto" : "14388295.62",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "282",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "C.R. TENANGO DE DORIA - EL GOSCO -LA VIEJITA",
        "monto" : "9245538.372",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "283",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "C.R. TENANGO DE DORIA - EL TEXME",
        "monto" : "8752546.782",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "284",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "C. R. SANTA MARÍA TEMAXCALAPA - CERRO CHIQUITO - EL PROGRESO - EL OCOTAL - RAMAL EL XAJA",
        "monto" : "44073200.06",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "285",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "CAMINO EL TRAMO - EL XINDHO",
        "monto" : "25148229.62",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "286",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "C.E. METEPEC-TENANGO-SANTA MARIA TEMAXCALAPA - HUASQUILLA- RAMALES AL DESPI",
        "monto" : "59021130.1284",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "287",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "C.E. CHILIJAPA-TEYAHUALA-TEXCAPA ",
        "monto" : "41000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "288",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "PUENTE PIEDRAS NEGRAS",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "289",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "PUENTE SAN FRANCISCO LAGUNA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "290",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "PUENTE CERRO CHIQUITO",
        "monto" : "9000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "291",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "CAMINO EL DAMO - SAN PABLO EL GRANDE ",
        "monto" : "46057738.1272",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "292",
        "dependencia" : "SICT",
        "municipio" : "TENANGO DE DORIA",
        "nombre" : "CAMINO EL DESDAVI - EL CASIU - LAS JUNTAS-RAMAL A LA REFORMA",
        "monto" : "21541003.4264",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "293",
        "dependencia" : "SIPDUS",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Rehabilitación de caminos afectados en el municipio de Tepehuacán de Guerrero",
        "monto" : "23151037.15",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "294",
        "dependencia" : "SIPDUS",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Construcción de pavimentación hidráulica de camino Texcapa - Petlapixca, primera etapa, en el municipio de Tepehuacán de Guerrero",
        "monto" : "14572470.78",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "295",
        "dependencia" : "SIPDUS",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Construcción de pavimentación hidráulica de camino Xilitla - Texopich, segunda etapa, en el municipio de Tepehuacán de Guerrero",
        "monto" : "2834813.01",
        "estatus" : "En ejecución",
        "fase" : "4"
    },
    {
        "num": "296",
        "dependencia" : "CEAA",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Rehabilitación de red o sistema de agua entubada en la localidad  de Villa de Ocampo",
        "monto" : "1563557.63",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1 "
    },
    {
        "num": "297",
        "dependencia" : "CEAA",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Rehabilitación de Red o Sistema de Agua Entubada en la localidad de Olcuatla",
        "monto" : "887377.5",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "298",
        "dependencia" : "CEAA",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Rehabilitación de red o sistema de agua entubada en la localidad de Acuimantla",
        "monto" : "1458397.74",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "299",
        "dependencia" : "CEAA",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Rehabilitación de red o sistema de agua entubada en la localidad de El Naranjal",
        "monto" : "1857755",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "300",
        "dependencia" : "CEAA",
        "municipio" : "Tepehuacán de Guerrero",
        "nombre" : "Rehabilitación de red o sistema de agua entubada en la localidad de Soyuco",
        "monto" : "656221.45",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "301",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "C.E. OTONGO - TEPEHUACAN",
        "monto" : "70000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "302",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "C.R. ACCESO A ACUIMANTLA",
        "monto" : "15000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "303",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "C.R. SAN JUAN AHUEHUECO - TENANGO - PALO VERDE",
        "monto" : "6900000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "304",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "SAN JUAN AHUEHUECO - TIZAPA",
        "monto" : "10100000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "305",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TRAMO AQUILASTEC",
        "monto" : "3200000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "306",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TRAMO CHAHUATITLA - CUATOLOL",
        "monto" : "5000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "307",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TRAMO EL NARANJAL - SOYUCO",
        "monto" : "12200000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "308",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TRAMO SOYUCO-TENANGO",
        "monto" : "2500000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "309",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "VILLA DE OCAMPO",
        "monto" : "1700000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "310",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "SAN SIMON - SAN MIGUEL AYOTEMPA",
        "monto" : "8400000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "311",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TEPEHUACAN - CHILIJAPA",
        "monto" : "20000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "312",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "CHILIJAPA - CUAZAHUATL",
        "monto" : "18000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "313",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "CUAZAHUATL - SAN JUAN AHUEHUECO",
        "monto" : "25000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "314",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "SAN JUAN AHUEHUECO-HUATEPANGO",
        "monto" : "30000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "315",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "SAN JUAN AHUEHUECO-AMOLA DE OCAMPO",
        "monto" : "5600000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "316",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "VILLA DE OCAMPO - OLCUATLA",
        "monto" : "2300000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "317",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TEYAHUALA - COYUTLA",
        "monto" : "1900000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "318",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "TEYAHUALA - XILITLA",
        "monto" : "5900000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "319",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "XILITLA - XILIAPA",
        "monto" : "5000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "320",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "XILIAPA - ACOYOTLA",
        "monto" : "6700000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "321",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "ACOYOTLA - TEXOPICH",
        "monto" : "5000000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "322",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "ACCESO A ZACATAL",
        "monto" : "3600000",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "323",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE VEHICULAR TAMALA – TEPEHUACÁN",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "324",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE CAHUAZAS",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "325",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE TENANGO (PUENTE PEATONAL PARA CRUCE DE CAÑADA)",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "326",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE IXTLAPALACO – HACIENDA CUHUAZAS",
        "monto" : "33500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "327",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE TLALOCUIL – ZACUALTIPANITO",
        "monto" : "30000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "328",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE CHALAHUITE",
        "monto" : "62500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "329",
        "dependencia" : "SICT",
        "municipio" : "TEPEHUACÁN DE GUERRERO",
        "nombre" : "PUENTE TENANGO – SOYUCO",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "330",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Extracción de derrumbes en el C.E. Tianguistengo - Yatipan - El Hormiguero - Tepaneca - Ixcotitlan, en el municipio de Tianguistengo",
        "monto" : "1014700.72",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "331",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Modernización del camino tramo Tianguistengo - Chinameca, en el municipio de Tianguistengo",
        "monto" : "16509208.43",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "332",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación de la C.E. La Morita - Los Naranjos, en el municipio de Tianguistengo",
        "monto" : "147024568.85",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "333",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación Circuito Tianguistengo (Polintontla - Tlacolula), en el municipio de Tianguistengo",
        "monto" : "54634314.47",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "334",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación Circuito Tianguistengo (El Hormiguero - Polintontla), en el municipio de Tianguistengo",
        "monto" : "50596036.69",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "335",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación del C.R. Xochimilco - E.C. Tianguistengo - Otlamalacatla, en el municipio de Tianguistengo",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "336",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación de la Carretera Santa Mónica - E.C. Ramal a Tianguistengo, en el municipio de Tianguistengo",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "337",
        "dependencia" : "SIPDUS",
        "municipio" : "Tianguistengo",
        "nombre" : "Reposición de línea de conducción de agua potable en la localidad de Pahuatitla, en el municipio de Tianguistengo",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "338",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación de cárcamo de agua potable en la localidad de Polintotla ",
        "monto" : "3000000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1 "
    },
    {
        "num": "339",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Construcción de fosas sépticas en la localidad de Tlacolula.",
        "monto" : "2999997.83",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "340",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación de línea de agua potable en la localidad de Cholula.",
        "monto" : "421727.74",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "341",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Reposición de agua potable en la localidad de El Ocotal",
        "monto" : "4028000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "342",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Reposición de 5 captaciones y rehabilitación de línea de agua potable en la localidad de Ixcotitlán",
        "monto" : "2759000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "343",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Construcción de línea de agua potable de Fo.go. Localidad de Joquela",
        "monto" : "2962037.17",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "344",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación de línea de agua potable en la localidad de La Morita",
        "monto" : "4074999.99",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "345",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Construcción de tanque de almacenamiento y línea de agua potable en la localidad de Matlatenco",
        "monto" : "3200000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "346",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Reposición de línea de conducción de agua potable en la localidad de Mazahuacan.",
        "monto" : "5025300.77",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "347",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Rehabilitación de línea de agua potable, cárcamos y equipamiento electromecánico en la localidad de Xalacahuantla",
        "monto" : "2247812.36",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "348",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Construcción de tanque de almacenamiento, fosa séptica y línea de agua potable en la localidad de Texacal.",
        "monto" : "1510000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "349",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Reposicion de captación y linea de conducción del sistema de agua potable en la localidad de Conchitlán",
        "monto" : "1760049.41",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "350",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Reposición de captación y línea de conducción del sistema de agua potable en la localidad de Tlahuiltepa",
        "monto" : "2000000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "351",
        "dependencia" : "CEAA",
        "municipio" : "Tianguistengo",
        "nombre" : "Construcción de línea de agua potable Fo.Go. En la localidad de Tlacolula",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 2"
    },
    {
        "num": "352",
        "dependencia" : "SICT",
        "municipio" : "TIANGUISTENGO",
        "nombre" : "PUENTE TLACOLULA",
        "monto" : "30000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "353",
        "dependencia" : "SICT",
        "municipio" : "TIANGUISTENGO",
        "nombre" : "PUENTE ACCESO A PUEBLO NUEVO, PEATONAL)*",
        "monto" : "65000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "354",
        "dependencia" : "SICT",
        "municipio" : "TIANGUISTENGO",
        "nombre" : "PUENTE TENEXCO",
        "monto" : "25000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "355",
        "dependencia" : "SICT",
        "municipio" : "TIANGUISTENGO",
        "nombre" : "PUENTE ZACATIPÁN",
        "monto" : "25000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "356",
        "dependencia" : "SICT",
        "municipio" : "TIANGUISTENGO",
        "nombre" : "PUENTE EL HORMIGUERO",
        "monto" : "22500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "357",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Construcción de pavimentación hidráulica del acceso al municipio de Tlahuiltepa, tramo Xilocuatitla-Los Pocitos, municipio de Tlahuiltepa",
        "monto" : "10643080.23",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "358",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Continuación de la construcción de pavimento de concreto hidráulico en acceso a cabecera de Tlahuiltepa",
        "monto" : "80669710.71",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "359",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Reposición de sistema de agua potable en la localidad de Coyacala, en el municipio de Tlahuiltepa",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "360",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación de línea de conducción, localidad de Xuchiatipa",
        "monto" : "3648183.1",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "361",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion, localidad de Boca de León",
        "monto" : "1114534.67",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "362",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion, localidad de Cerro Chato",
        "monto" : "588153.12",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "363",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion, localidad de Chichicaxtla",
        "monto" : "2317483.25",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "364",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion localidad de El Duraznito",
        "monto" : "1720118.05",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "365",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion, localidad de El Roble",
        "monto" : "2291072.02",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "366",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion localidad de Las Manzanas",
        "monto" : "1446576.98",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "367",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Sistema de agua potable en la localidad de Las Pilas",
        "monto" : "1755725.84",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "368",
        "dependencia" : "CEAA",
        "municipio" : "Tlahuiltepa",
        "nombre" : "Rehabilitación del sistema de agua potable y red de distribucion localidad de Xiopa",
        "monto" : "1971057.92",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "369",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "C.R. CERRO DEL AGUILA - CERRO CHATO ",
        "monto" : "16587061.8848",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "370",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "C.R. EL PALMAR - LA MAROMA",
        "monto" : "22258637.6584",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "371",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "C.R. LA MAROMA - OTATLA",
        "monto" : "5044191.11",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "372",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "C.R. TOLANTONGO - LA LAGUNA CAMARONES",
        "monto" : "20823442.205728",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "373",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "CR. EL ROBLE - LAS MANZANAS - XIOPA",
        "monto" : "33896951.342",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "374",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "ENTR. LA MAROMA - SAN ANDRES MIRAFLORES",
        "monto" : "18331634.75568",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "375",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "SAN ANDRES MIRAFLORES -  LAZARO CARDENAS",
        "monto" : "10567106.1768",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "376",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PALMITAS -  BOCA DE LEON",
        "monto" : "16427966.8872",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "377",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "EL VENADO -  BUENA VISTA",
        "monto" : "27628756.6",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "378",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "BUENA VISTA - BOCA DE LEON",
        "monto" : "16543075.7312",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "379",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "ACAPA - TLAHUILTEPA",
        "monto" : "25529194.4756",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "380",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "NUEVO MORELOS - TLAXCANTITLA",
        "monto" : "11924358.732",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "381",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "TLAXCANTITLA - SAN MARCOS - ITZMICHAPA",
        "monto" : "50495514.5728",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "382",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "SAN MARIA -  TLAHUILTEPA (A LA ALTURA DE TLAXCANTITLA)",
        "monto" : "5126508.0832",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "383",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "ACCESO A LA CONCORDIA Y SAN ANDRESITO",
        "monto" : "4656389.4776",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "384",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : " TLAHUILTEPA - ENTRONQUE TEPEHUACAN DE GUERRERO",
        "monto" : "45185945.9552",
        "estatus" : "Contratada",
        "fase" : "CAMINO"
    },
    {
        "num": "385",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE BOCA DE LEON - LA MISION",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "386",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE VADO JONACAPA - CHICHICAXTLA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "387",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE VADO ITZTAMICHAPA",
        "monto" : "25000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "388",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE LA MAROMA - EL PALMAR",
        "monto" : "40000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "389",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE LAS PILAS - LA VEGA DE LA CARRERA. PEATONAL)*",
        "monto" : "36000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "390",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE DOMINÍ - BUENA VISTA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "391",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE VADO SAN ANDRÉS - LA CONCORDIA-MIRAFLORES)",
        "monto" : "47500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "392",
        "dependencia" : "SICT",
        "municipio" : "TLAHUILTEPA",
        "nombre" : "PUENTE ACCESO A LAZARO CARDENAS",
        "monto" : "48000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "393",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Modernización y ampliación del camino rural Huazalingo - Tlanchinol, segunda etapa, en la localidad de olotla, en el municipio de Tlanchinol",
        "monto" : "6061735.41",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "394",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Modernización y ampliación de C.R. Temango - Jalpa, en el municipio de Tlanchinol",
        "monto" : "13820334.89",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "395",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de caminos afectados en el municipio de Tlanchinol",
        "monto" : "22830415.39",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "396",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación del Camino Rural Jalpa - La Florida, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "397",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación del camino Pilcuatla - E.C. Tlanchinol, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "398",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Reabilitación de la C.E Temango - Jalpa, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "399",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de la C.E. Orizatlán – Coacuilco - San José - E.C.F. (Pachuca - Tempoal) km. 0+000 al 8+000, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "400",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Reconstrucción del C.R (E.C.F. Pachuca - Huejutla) Ajacaya - San Cristobal, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "401",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Reconstrucción de la C.E. Acatempa - San Salvador - Toctitlan, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "402",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación del Camino Rural Cerro Alto - Cuatatlán - Tierra Colorada , en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "403",
        "dependencia" : "SIPDUS",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de la C.E. Chalchocotipa - Santa María, en el municipio de Tlanchinol",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "404",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales para la localidad de Chichatla",
        "monto" : "800000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 1"
    },
    {
        "num": "405",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de Planta de Tratamiento de Aguas Residuales en Tlanchinol, localidad Lontla",
        "monto" : "600000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "406",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de Línea de Conducción en Sistema de Agua Potable en Tlanchinol localidad Cuatlapech.",
        "monto" : "1000000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 2"
    },
    {
        "num": "407",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales en Tlanchinol localidad Hueyapa",
        "monto" : "559878",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "408",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales en Tlanchinol localidad Jalpa",
        "monto" : "700000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "409",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales para la localidad de Tierra Colorada",
        "monto" : "700000",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "410",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de la planta de tratamiento de aguas residuales, localidad de Toctitlán",
        "monto" : "800095",
        "estatus" : "En ejecución",
        "fase" : "Vaguada 3"
    },
    {
        "num": "411",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales para la localidad de Santa María",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "412",
        "dependencia" : "CEAA",
        "municipio" : "Tlanchinol",
        "nombre" : "Rehabilitación de planta de tratamiento de aguas residuales para la localidad de Acatipa",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "413",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Modernización con pavimento hidráulico del camino entronque Xochiatipan a Pahuatitla - Nuevo Coyolar - Pachiquitla, en el municipio de Xochiatipan",
        "monto" : "4826270.11",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "414",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Construcción de pavimento hidráulico del camino Acatipa - Texoloc, en el municipio de Xochiatipan",
        "monto" : "2993315.12",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "415",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Construcción de puente vehicular en la localidad de Ohuatipa, en el municipio de Xochiatipan",
        "monto" : "27320000",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "416",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Rehabilitación de la C.E. Xochiatipan - Atlalco, en el municipio de Xochiatipan",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "417",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Rehabilitación de la C.E. Ramal a Xochiatipan km. 5+000 al 12+000, en el municipio de Xochiatipan",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "418",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Rehabilitación de la C.E. Ohuatipa – Ixtaczoquico – Ahuatitla - Texoloc, en el municipio de Xochiatipan",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "419",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochiatipan",
        "nombre" : "Construcción de muros de protección sobre Rivera del Río Ohuatipa, en el municipio de Xochiatipan",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "420",
        "dependencia" : "CEAA",
        "municipio" : "Xochiatipan",
        "nombre" : "Línea de conducción por bombeo en la localidad de Pohuantitla",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "421",
        "dependencia" : "SICT",
        "municipio" : "XOCHIATIPAN",
        "nombre" : "PUENTE GARCES",
        "monto" : "45000000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "422",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Construcción de pavimento de concreto hidráulico en el tramo: Coatlamayan - Acatepec, del km. 0+000 al km. 1+884, subtramo: del km. 0+000 al km. 1+000, en la localidad de Acatepec, municipio de Xochicoatlán",
        "monto" : "8198498.5",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "423",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación de la C.E. Molango - Xochicoatlán, del tramo afectado en el municipio de Xochicoatlán",
        "monto" : "3722451.21",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "424",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Xochicoatlán - Tuzancoac, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "425",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R Jalamelco   - Texcaco, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "426",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Tenango – Epopulco - Otonapa, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "427",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Papaxtla - E.C. Xochicoatlán - Tuzancoac, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "428",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Xochicoatlán- Coatitlamixtla, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "429",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Acatepec- Tlaxcoya - Mazahuacán, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "430",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Xochicoatlán - Tuzancoac - E.C. Molangotzi, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "431",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación del C.R. Molangotzi - Mixtla, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "432",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación de la C.R. Acomulco - E.C. Xochicoatlán - Molango, en el municipio de Xochicoatlán",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "433",
        "dependencia" : "SIPDUS",
        "municipio" : "Xochicoatlán",
        "nombre" : "Modernización y ampliación del camino rural Xochicoatlán - Tianguistengo, en el municipio de Xochicoatlán.",
        "monto" : "24303040.44",
        "estatus" : "Concluida",
        "fase" : "4"
    },
    {
        "num": "434",
        "dependencia" : "CEAA",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación de línea de conducción de agua potable en la localidad de Texcaco",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "435",
        "dependencia" : "CEAA",
        "municipio" : "Xochicoatlán",
        "nombre" : "Rehabilitación de líneas y cajas de captación del sistema de agua potable en la localidad de Tlaxcoya",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "Vaguada 3"
    },
    {
        "num": "436",
        "dependencia" : "SIPDUS",
        "municipio" : "Yahualica",
        "nombre" : "Rehabilitación de la C.E. E.C. (Lolotla - Atlapexco) - Los Naranjos - Yatipan, en el municipio de Yahualica",
        "monto" : "24721196.75",
        "estatus" : "Concluida",
        "fase" : "2"
    },
    {
        "num": "437",
        "dependencia" : "SIPDUS",
        "municipio" : "Yahualica",
        "nombre" : "Rehabilitación de la C.E. Tlalchiyahualica - Zoquitipán, en el municipio de Yahualica",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "438",
        "dependencia" : "SIPDUS",
        "municipio" : "Yahualica",
        "nombre" : "Rehabilitación del C.R. Atlalco - Mangocoatitla, en el municipio de Yahualica",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "439",
        "dependencia" : "SIPDUS",
        "municipio" : "Yahualica",
        "nombre" : "Rehabilitación del C.R. Zacayahual - Chompeletla, en el municipio de Yahualica",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "440",
        "dependencia" : "SIPDUS",
        "municipio" : "Yahualica",
        "nombre" : "Rehabilitación del C.R. acceso a Olma, en el municipio de Yahualica",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "441",
        "dependencia" : "SIPDUS",
        "municipio" : "Yahualica",
        "nombre" : "Reconstrucción de la C.E. (Lolotla - Atlapexco) - Santa Teresa, en el municipio de Yahualica",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "442",
        "dependencia" : "SICT",
        "municipio" : "YAHUALICA",
        "nombre" : "PUENTE SAN SALVADOR",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "443",
        "dependencia" : "SICT",
        "municipio" : "YAHUALICA",
        "nombre" : "PUENTE LOS NARANJOS",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "444",
        "dependencia" : "SICT",
        "municipio" : "YAHUALICA",
        "nombre" : "PUENTE PEPEYOCATITLA",
        "monto" : "3500000",
        "estatus" : "Contratada",
        "fase" : "PUENTE"
    },
    {
        "num": "445",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Pavimentación y drenaje sanitario de la calle del Campo de fútbol en la comunidad de Jalapa, en el municipio de Zacualtipán de Ángeles",
        "monto" : "1987739",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "446",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Pavimentación de la calle entrada Principal de la comunidad de Tehuitzila, en el municipio de Zacualtipán de Ángeles",
        "monto" : "3940691.84",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "447",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Pavimentación de la entrada Principal de la comunidad de Sietla, en el municipio de Zacualtipán de Ángeles",
        "monto" : "1996422.15",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "448",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Pavimentación de la calle Principal de la comunidad de Coatlila, en el municipio de Zacualtipán de Ángeles.",
        "monto" : "3889554.25",
        "estatus" : "Concluida",
        "fase" : "1"
    },
    {
        "num": "449",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación de diversos caminos a Zacualtipán, en el municipio de Zacualtipán de Ángeles",
        "monto" : "9985273.23",
        "estatus" : "Concluida",
        "fase" : "2"
    },
    {
        "num": "450",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación de la  C.E. Zacualtipán - Tianguistengo, en el municipio de Zacualtipán de Ángeles",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "3"
    },
    {
        "num": "451",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación del C.R. Zacualtipán - Soyatla, en el municipio de Zacualtipán de Ángeles",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "452",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación del C.R. Ramal Ohuesco - Jalapa, en el municipio de Zacualtipán de Ángeles",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "453",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación del C.R. Tzincoatlán, (e.c. la Mojonera - Tlahuelompa), en el municipio de Zacualtipán de Ángeles",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "454",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación del C.R. Tetzimico E.C. (Ohuesco - Jalapa), en el municipio de Zacualtipán de Ángeles",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "455",
        "dependencia" : "SIPDUS",
        "municipio" : "Zacualtipán de Ángeles",
        "nombre" : "Rehabilitación de la C.E. Ramal a Tlahuelompa, en el municipio de Zacualtipán de Ángeles",
        "monto" : "",
        "estatus" : "En contratación",
        "fase" : "3"
    },
    {
        "num": "456",
        "dependencia" : "SIPDUS",
        "municipio" : "Zimapán",
        "nombre" : "Rehabilitación del C.R. Las Adjuntas - Mina El Carrizal, en el municipio de Zimapán",
        "monto" : "18554505.42",
        "estatus" : "En ejecución",
        "fase" : "2"
    },
    {
        "num": "457",
        "dependencia" : "SIPDUS",
        "municipio" : "Zimapán",
        "nombre" : "Rehabilitación de C.E. La Estancia - Pacula, tramo La Estancia - Potreritos, en el municipio de Zimapán",
        "monto" : "30779545.3",
        "estatus" : "En ejecución",
        "fase" : "4"
    },
    {
        "num": "458",
        "dependencia" : "SIPDUS",
        "municipio" : "Zimapán",
        "nombre" : "Interconexión del pozo profundo de agua potable La Cruz III con el acueducto de la Cruz, en el municipio de Zimapán ",
        "monto" : "",
        "estatus" : "En validación",
        "fase" : "4"
    },
    {
        "num": "459",
        "dependencia" : "SIPDUS",
        "municipio" : "Zimapán",
        "nombre" : "Rehabilitación de sistema de agua potable en la localidad de Camposanto del Oro, en el municipio de Zimapán",
        "monto" : "777873.84",
        "estatus" : "En ejecución",
        "fase" : "4"
    }
    ]